module.exports = __webpack_public_path__ + "static/media/laptopWork.17c9ffe2.png";